import React, {useContext, useEffect} from "react";
import {IntlContext} from "./IntlContext";

const LanguageSwitcher = ({enabledLanguages = {en: true, de: true}}) => {

    const {switchLanguage, locale} = useContext(IntlContext);

    useEffect(() => {
        if (!enabledLanguages.de) {
            switchLanguage('en');
        }
    });

    if (!enabledLanguages.de || !enabledLanguages.en) return null;

    const toggle = (e) => {
        e.preventDefault();
        switchLanguage(locale === 'en' ? 'de' : 'en');
    };

    return (
        // eslint-disable-next-line
        <a className="language-switcher" href="#"
           onClick={toggle}>{locale === 'en' ? 'Deutsch' : 'English'}</a>
    );
};

export default LanguageSwitcher;
